import React,{useRef,useEffect} from 'react'
import {
    Form,
  Input,
  Radio,
  Space,ProgressBar,
  Button,Selector,TextArea,ImageUploader,NavBar,Image,Picker,Toast,DatePicker
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import {
    GetDataDictionarysByCode,SaveAlbum,GetAlbumsById,SaveNNFile,PostAlbumClass,GetSystemMemorys,GetWXJSSDK
  } from '../../service/service';
import { RightOutline } from 'antd-mobile-icons';

import {
    DndContext,
    DragEndEvent,
    closestCorners,
    useSensors,
    useSensor,
    TouchSensor,
    MouseSensor,
} from '@dnd-kit/core';
import {
    SortableContext,
    useSortable,
    horizontalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../AlbumUpload/index.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

const SortableImageItem = ({ file, index }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: file.url,
        index,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        width: '80px',
        height: '80px',
        touchAction: 'none',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
        >
            <img
                src={file.url}
                alt="上传图片"
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '8px',
                }}
            />
        </div>
    );
};

// 传感器组件（用于在class组件中使用hooks）
const DragSensors = ({ children }) => {
    const sensors = useSensors(
        useSensor(TouchSensor, { delay: 300 }), // 长按300ms触发拖拽
        useSensor(MouseSensor)
    );

    return children(sensors);
};


class Index extends React.Component {
    formRef = React.createRef();
    fileInputRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            planetId: 0,
            tabIdx: 0,
            navIdx: 0,
            fileList: [],
            imgName: '',
            disableDrag: false,

            visibleOne: false,
            valuePickerOne: "1",
            textPickerOne: "请选择",
            pickerOne: [
                [
                ]
            ],

            visibleTwo: false,
            valuePickerTwo: "1",
            textPickerTwo: "请选择",
            pickerTwo: [
                [
                ]
            ],

            isSubmit: true,
            albumInfo: {},
            
            loadingProgress: 0,
            loadingType: '',
            maxCount: 3,
        };
    }

    handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        // 重新排序文件列表
        const newFileList = [...this.state.fileList];
        const activeIndex = newFileList.findIndex(file => file.url === active.id);
        const overIndex = newFileList.findIndex(file => file.url === over.id);

        if (activeIndex !== -1 && overIndex !== -1) {
            const [movedFile] = newFileList.splice(activeIndex, 1);
            newFileList.splice(overIndex, 0, movedFile);
            this.setState({ fileList: newFileList });
        }
    };

    // 处理文件删除
    handleDelete = (index) => {
        const newFileList = this.state.fileList.filter((_, i) => i !== index);
        this.setState({
          fileList: newFileList,
        });
    };

    // 新增：拖拽开始前判断是否点击了删除按钮
    handleDragStart = (event) => {
        // 1. 获取拖拽开始时的坐标（触摸/鼠标位置）
        const { clientOffset } = event.active;
        if (!clientOffset) return; // 无坐标信息则不处理
      
        // 2. 根据坐标获取点击的DOM元素
        const targetElement = document.elementFromPoint(
          clientOffset.x,
          clientOffset.y
        );
      
        // 3. 判断是否点击了删除按钮
        const isDeleteButton = targetElement.closest('.delete-button');
        
        // 4. 点击删除按钮则阻止拖拽
        if (isDeleteButton) {
          return false;
        }
    };

    componentDidMount() {
        const script = document.createElement('script');
        script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
        script.async = true;
        document.body.appendChild(script);

        var that = this;

        const { location } = this.props;
        const { planetId, id, tabIdx, navIdx } = location.state || {}; // 获取 URL 参数
        this.setState({
            planetId: planetId,
            id: id,
            tabIdx: tabIdx,
            navIdx: navIdx,
            valuePickerOne: tabIdx,
            valuePickerTwo: navIdx,
            TabTypeId: tabIdx,
            PhotoTypeId: navIdx,
        })

        GetDataDictionarysByCode("XiangCeLX").then(res => {
            if (res.success) {
                var arry = [];
                var textPickerOne = "请选择";
                res.result.map((item, index) => {
                    arry.push({ label: item.displayName, value: item.id })
                    if (item.id == tabIdx) {
                        textPickerOne = item.displayName;
                    }
                })
                that.setState({
                    pickerOne: [arry],
                    textPickerOne: textPickerOne,
                })
            }
        })

        that.loadAlbumClass(tabIdx, navIdx);

        this.formRef.current.setFieldsValue({
            ShootDate: new Date('2000-01-01'),
        })

        if (id) {
            GetAlbumsById(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    this.formRef.current.setFieldsValue({
                        Remark: res.result.remark,
                        ShootDate: res.result.shootDate,
                    })

                    that.loadAlbumClass(result.tabTypeId, navIdx);

                    setTimeout(() => {
                        var item1 = that.state.pickerOne[0].filter(x => x.value == result.tabTypeId);

                        setTimeout(() => {
                            var item2 = that.state.pickerTwo[0].filter(x => x.value == result.photoTypeId);

                            that.setState({
                                valuePickerTwo: result.photoTypeId,
                                textPickerTwo: item2[0] == null ? "请选择" : item2[0].label
                            })
                        }, 1000);

                        that.setState({
                            valuePickerOne: result.tabTypeId,
                            textPickerOne: item1[0] == null ? "请选择" : item1[0].label,
                        })
                    }, 1000);

                    var list = []
                    result.imgs.map((item, index) => {
                        list.push({
                            key: 999 - index,
                            url: environment.apiEndpoint + item,
                            thumbnailUrl: environment.apiEndpoint + item,
                        })
                    })

                    that.setState({
                        // id: id,
                        // imgName: result.headImg,
                        albumInfo: result,
                        fileList: list,
                    })
                }
            })
        }
        

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })


        var jsApiList = [
            'checkJsApi',
            'openLocation',
            'chooseImage',
        ];

        setTimeout(() => {

            var url = window.location.href.split('#')[0];
            url = encodeURIComponent(url);

            GetWXJSSDK(url).then(res => {
                var json = JSON.parse(res.result);
                json.jsApiList = jsApiList;
                json.appId = json.AppId;
                json.debug = true;
                json.nonceStr = json.noncestr;
                // window.wx.config(json);
                var configStr = {
                    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                    appId: json.appId, // 必填，公众号的唯一标识
                    timestamp: parseInt(json.timestamp), // 必填，生成签名的时间戳
                    nonceStr: json.nonceStr, // 必填，生成签名的随机串
                    signature: json.signature,// 必填，签名
                    jsApiList: jsApiList, // 必填，需要使用的 JS 接口列表
                };
                window.wx.config(configStr);
            })

        }, 1000);

        // const fileInput = document.querySelector('input[type=file][accept="image/*"]');
        // if (fileInput) {
        //   this.fileInputRef.current = fileInput;
        //   // 覆盖原生选择器的change事件，提前拦截多选数量
        //   fileInput.addEventListener('change', (e) => {
        //     const files = e.target.files;
        //     const maxCount = 3;
        //     if (files.length > maxCount) {
        //       Toast.show({ icon: 'fail', content: `最多只能选择${maxCount}张图片！` });
        //       // 清空选择器，阻止后续流程
        //       e.target.value = '';
        //     }
        //   });
        // }

    }

    loadAlbumClass = (tabIdx, navIdx) => {
        var that = this;

        const { location } = that.props;
        const { planetId, id } = location.state || {}; // 获取 URL 参数
        const data = {
            PlanetId: planetId,
            MaxResultCount: 999,
            SkipCount: 0,
            TabTypeId: tabIdx === 0 ? undefined : tabIdx
        };
        PostAlbumClass(data).then(res => {
            if (res.success) {
                var arry = [];
                var textPickerTwo = "请选择";
                res.result.map((item, index) => {
                    arry.push({ label: item.name, value: item.id })
                    if (index == 0 && navIdx == 0) {
                        textPickerTwo = item.name;
                        navIdx = item.id;
                    }
                    if (item.id == navIdx) {
                        textPickerTwo = item.name;
                    }
                })
                that.setState({
                    pickerTwo: [arry],
                    textPickerTwo: textPickerTwo,
                    valuePickerTwo: navIdx,
                    PhotoTypeId: navIdx,
                })
            }
        })
    }

    simulateDataLoading = () => {
        const progressInterval = setInterval(() => {
            this.setState(prevState => {
                const newProgress = Math.min(
                    prevState.loadingProgress + Math.floor(Math.random() * 5) + 1, 
                    100
                );
                
                if (newProgress >= 100) {
                    clearInterval(progressInterval);
                    setTimeout(() => {
                        this.setState({
                            dataMsg: "数据加载完成",
                        });
                    }, 800);
                }
                if (newProgress > 95) {
                    return { loadingProgress: 95 };
                }
                return { loadingProgress: newProgress };
            });
        }, 2000);
    }

    submitForm = () => {
        var that = this;
        if (!that.state.isSubmit) {
            Toast.show({ icon: 'fail', content: '文件上传中，请稍等！' });
            return;
        }
        this.formRef.current.validateFields()
            .then(values => {
                var imgs = [];
                this.state.fileList.map(item => {
                    imgs.push(item.url.split('/').pop());
                });
                that.state.albumInfo.imgs = [];
                
                if (imgs.length == 0) {
                    Toast.show({ icon: 'fail', content: '请最少上传一张图片！' });
                    return;
                }

                if (values.ShootDate == null) {
                    Toast.show({ icon: 'fail', content: '请选择拍摄时间！' });
                    return;
                }

                const submitData = {
                    ...that.state.albumInfo,
                    ...values,
                    ShootDate: dayjs(values.ShootDate).format('YYYY-MM'),
                    TabTypeId: this.state.valuePickerOne,
                    PhotoTypeId: this.state.valuePickerTwo,
                    Imgs: imgs,
                    PlanetId: this.state.planetId,
                };

                const loadingToast = Toast.show({ icon: 'loading', content: '提交中...', duration: 0 });

                SaveAlbum(submitData).then(res => {
                    loadingToast.close();
                    if (res.success) {
                        Toast.show({ icon: 'success', content: '提交成功！' });
                        setTimeout(() => {
                            that.props.navigate('/albumClass', { replace: true, state: { id: that.state.planetId } });
                        }, 2000);
                    }

                })
            })
            .catch(error => {
                if (error.errorFields) {
                    Toast.show({ icon: 'fail', content: '请检查表单' });
                } else {
                    Toast.show({ icon: 'fail', content: error.message || '提交失败' });
                }
            });
        
    }




    // 核心：调用微信JS-SDK选择图片（限制最多3张）
    chooseWxImage = () => {
        const { maxCount, fileList } = this.state;
        const remainCount = maxCount - fileList.length; // 剩余可选择数量

        // 已选满3张，直接提示
        if (remainCount <= 0) {
            Toast.show({ icon: 'fail', content: `最多只能选择${maxCount}张图片！` });
            return;
        }

        // 调用微信JS-SDK的chooseImage接口（选择器内限制数量）
        window.wx.chooseImage({
            count: remainCount, // 关键：选择器内最多选剩余数量
            sizeType: ['original', 'compressed'], // 允许原图/压缩图
            sourceType: ['album', 'camera'], // 允许相册/拍照
            success: async (res) => {
                const localIds = res.localIds; // 微信返回的本地图片ID列表
                await this.convertLocalIdsToFiles(localIds); // 转换为File对象
            },
            fail: (err) => {
                console.error('选择图片失败:', err);
                Toast.show({ icon: 'fail', content: '选择图片失败' });
            }
        });
    };

    // 核心：多策略获取微信图片数据（兼容所有localId格式）
    getWxImageData = async (localId) => {
        return new Promise((resolve) => {
            // 策略1：优先调用微信JS-SDK的getLocalImgData（iOS/高版本Android）
            const tryWxApi = () => {
                window.wx.getLocalImgData({
                    localId: localId,
                    success: (res) => {
                        if (res.localData) {
                            resolve(res.localData);
                        } else {
                            tryFetch(); // 降级到策略2
                        }
                    },
                    fail: () => tryFetch() // 失败则降级
                });
            };

            // 策略2：直接fetch获取（Android版http开头的localId）
            const tryFetch = () => {
                if (!localId.startsWith('http')) {
                    tryBlobReader(); // 非http则降级到策略3
                    return;
                }
                fetch(localId)
                    .then(res => {
                        if (!res.ok) throw new Error('图片请求失败');
                        return res.blob();
                    })
                    .then(blob => {
                        const reader = new FileReader();
                        reader.onload = () => {
                            // 提取base64（去掉前缀）
                            const base64 = reader.result.split(',')[1];
                            resolve(base64);
                        };
                        reader.onerror = () => tryBlobReader();
                        reader.readAsDataURL(blob);
                    })
                    .catch(() => tryBlobReader());
            };

            // 策略3：直接解析blob格式（PC版/低版本Android）
            const tryBlobReader = () => {
                if (!localId.startsWith('blob')) {
                    resolve(null); // 所有策略失败，返回null
                    return;
                }
                const reader = new FileReader();
                reader.onload = () => {
                    const base64 = reader.result.split(',')[1];
                    resolve(base64);
                };
                reader.onerror = () => resolve(null);
                fetch(localId)
                    .then(res => res.blob())
                    .then(blob => reader.readAsDataURL(blob))
                    .catch(() => resolve(null));
            };

            // 执行策略1（优先走微信官方API）
            tryWxApi();
        });
    };

    // base64转Blob（兼容所有格式）
    dataURLtoBlob = (base64Str) => {
        try {
            // 补全base64前缀（若缺失）
            let dataURL = base64Str;
            if (!dataURL.startsWith('data:')) {
                dataURL = `data:image/jpeg;base64,${dataURL}`;
            }
            // 兼容微信拼写错误（jgp→jpg）
            dataURL = dataURL.replace('image/jgp', 'image/jpg');
            // 解析base64
            const arr = dataURL.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        } catch (err) {
            console.error('base64转Blob失败:', err);
            return null;
        }
    };

    // 全兼容：将微信localId转为File对象
    convertLocalIdsToFiles = async (localIds) => {
        const { maxCount, fileList } = this.state;
        const newFiles = [];

        // 前置校验：微信环境 + localIds有效
        if (!window.wx || !Array.isArray(localIds) || localIds.length === 0) {
            Toast.show({ icon: 'fail', content: '选择图片失败，请在微信中操作' });
            return;
        }

        // 遍历所有localId，逐个转换
        for (let i = 0; i < localIds.length; i++) {
            const localId = localIds[i];
            try {
                // 仅校验localId非空（放弃格式校验）
                if (!localId || typeof localId !== 'string' || localId.trim() === '') {
                    console.error(`第${i + 1}张图片localId无效:`, localId);
                    Toast.show({ icon: 'fail', content: `第${i + 1}张图片无效` });
                    continue;
                }

                // 多策略获取图片base64数据（核心兼容逻辑）
                const base64Data = await this.getWxImageData(localId);
                if (!base64Data) {
                    console.error(`第${i + 1}张图片获取失败: localId=${localId}`);
                    Toast.show({ icon: 'fail', content: `第${i + 1}张图片获取失败` });
                    continue;
                }

                // base64转Blob
                const blob = this.dataURLtoBlob(base64Data);
                if (!blob || blob.size === 0) {
                    console.error(`第${i + 1}张图片格式错误: blob=${blob}`);
                    Toast.show({ icon: 'fail', content: `第${i + 1}张图片格式错误` });
                    continue;
                }

                // 构建File对象
                const fileName = `wx_image_${Date.now()}_${i}.jpg`;
                const file = new File([blob], fileName, { type: 'image/jpeg' });
                if (file.size === 0 || file.size > 5 * 1024 * 1024) {
                    console.error(`第${i + 1}张图片大小异常: ${file.size}B`);
                    Toast.show({ icon: 'fail', content: `第${i + 1}张图片大小不能超过5MB` });
                    continue;
                }

                // 业务校验（星球空间）
                const isValid = await this.validateFile(file);
                if (isValid) {
                    newFiles.push(file);
                }
            } catch (err) {
                console.error(`第${i + 1}张图片转换失败:`, err);
                Toast.show({ icon: 'fail', content: `第${i + 1}张图片转换失败: ${err.message || '未知错误'}` });
            }
        }

        const newUrlFiles = [];
        for (let i = 0; i < newFiles.length; i++) 
        {
            var model = await this.handleUpload(newFiles[i]);
            newUrlFiles.push(model);
        }

        // 更新文件列表（确保不超maxCount）
        const finalFileList = [...fileList, ...newUrlFiles].slice(0, maxCount);
        // 🌟 核心修改：计算是否选满，存入状态
        const isFull = finalFileList.length >= maxCount;
        this.setState({
            fileList: finalFileList,
            isSubmit: true,
            loadingType: '',
            isFull // 新增状态：标记是否选满
        });
    };

    // 业务校验（复用原有逻辑，增加异常捕获）
    validateFile = async (file) => {
        try {
            const res = await GetSystemMemorys(this.state.planetId);
            if (!res.success) return true; // 接口失败则跳过空间校验

            let count = 0;
            res.result.forEach(item => {
                count += item.fileSize || 0;
            });
            let maxSize = 300;
            const models = this.state.userInfo.planetSizes.filter(x => x.planetId === this.state.planetId) || [];
            if (models.length > 0) {
                maxSize = models[0].fileSumSize || 300;
            }
            if (count > maxSize) {
                Toast.show({ content: '该星球文件空间已满！' });
                return false;
            }

            // 设置加载状态
            this.setState({
                isSubmit: false,
                loadingProgress: 0,
                loadingType: 'progress',
            });
            this.simulateDataLoading();
            return true;
        } catch (err) {
            console.error('文件业务校验失败:', err);
            Toast.show({ icon: 'fail', content: '文件校验失败，请重试' });
            return false;
        }
    };

    // 复用原有上传逻辑
    handleUpload = async (file) => {
        try {
            console.log('Upload - 开始上传:', file);

            // 1. 验证文件对象
            if (!(file instanceof File)) {
                throw new Error('无效的文件对象');
            }

            // 2. 创建临时预览URL
            const tempUrl = URL.createObjectURL(file);
            console.log('临时预览URL创建成功:', tempUrl);

            // 3. 上传文件
            const formData = new FormData();
            formData.append('file', file);
            formData.append('userid', this.state.userInfo.id);
            formData.append('scoureName', "XC");
            formData.append('planetId', this.state.planetId);

            const response = await SaveNNFile(formData);
            console.log('上传响应:', response);

            // 4. 确保返回正确的URL格式
            let imageUrl;
            if (typeof response === 'string') {
                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
            } else if (response.result) {
                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
            } else {
                throw new Error('无效的服务器响应');
            }

            this.setState({
                imgName: response.result
            });
            // 5. 释放临时URL
            URL.revokeObjectURL(tempUrl);

            return {
                url: imageUrl
            };
        } catch (error) {
            console.error('上传过程出错:', error);
            Toast.show({ icon: 'fail', content: '上传失败' });
            throw error;
        }
    };

    render() {
        const { fileList, loadingProgress, loadingType } = this.state;
        const isFull = fileList.length >= this.state.maxCount;

        return (
            <div style={{ height: "100%", width: "100%", backgroundColor: "rgb(227 227 227)" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/albumClass', { replace: true, state: { id: this.state.planetId } }); // 传递状态
                }}>
                    照片上传
                </NavBar>

                <div className="albumUpload" style={{
                    width: "92%", marginLeft: "3%", backgroundColor: "#fff", borderRadius: "2%", marginTop: "3%",
                    height: "82%", overflowY: "scroll"
                }}>

                    <div style={{ width: "92%", marginLeft: "3%", paddingBottom: "3%", paddingTop: "3%" }}>

                        <Form
                            name='form'
                            ref={this.formRef}
                            layout='horizontal'
                            footer={
                                <div>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/2-13.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , marginLeft: "5%", width: "90%", textAlign: "center", fontSize: "17px"
                                        , lineHeight: "38px", fontWeight: "600", color: "#fff"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        提 交
                                    </div>
                                </div>
                            }
                        >


                            <div style={{ marginTop: "7px", marginBottom: "15px" }}>

                                <div style={{ textAlign: "center", fontSize: "13px", color: "#f00", marginBottom: "10px" }}>
                                    温馨提示：可拖拽图片进行排序
</div>

                                {loadingType === 'progress' && (
                                    <div className="progress-loading" style={{ margin: "auto", width: "90%" }}>
                                        <ProgressBar
                                            percent={loadingProgress}
                                            style={{
                                                '--track-width': '6px',
                                                '--fill-color': '#1677ff',
                                                '--track-color': 'rgba(22, 119, 255, 0.1)'
                                            }}
                                        />
                                    </div>
                                )}

                                {/* 拖拽上下文 */}
                                <DragSensors>
                                    {(sensors) => (
                                        <DndContext
                                            sensors={sensors}
                                            collisionDetection={closestCorners}
                                            onDragEnd={this.handleDragEnd}
                                        >
                                            <SortableContext
                                                items={fileList.map(file => file.url)}
                                                strategy={horizontalListSortingStrategy}
                                            >
                                                {/* 列表容器：每个项包含「拖拽图片」和「外部删除按钮」 */}
                                                <div style={{
                                                    display: 'flex', flexWrap: 'wrap', gap: '20px'
                                                    , margin: "5%", marginTop:"0px"
                                                }}>
                                                    {fileList.map((file, index) => (
                                                        <div key={file.url} style={{ position: 'relative' }}>
                                                            {/* 1. 可拖拽图片（仅图片区域可拖拽） */}
                                                            <SortableImageItem
                                                                file={file}
                                                                index={index}
                                                            />

                                                            {/* 2. 完全独立的删除按钮（在拖拽元素外部） */}
                                                            <div
                                                                onClick={() => {
                                                                    console.log('删除按钮点击，索引：', index);
                                                                    this.handleDelete(index);
                                                                }}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-2px',
                                                                    right: '-14px',
                                                                    width: '24px',
                                                                    height: '24px',
                                                                    zIndex: 9999, // 确保在最上层
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                <Image
                                                                    src="https://api.weibinyi.com/images/niannian/4/40-13.png"
                                                                    fit="fill"
                                                                    width={14}
                                                                    height={14}
                                                                    alt="删除"
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </SortableContext>
                                        </DndContext>
                                    )}
                                </DragSensors>

                                <ImageUploader
                                    columns={3}
                                    maxCount={3}
                                    multiple={true}
                                    style={{ '--cell-size': '80px', display: "none" }}
                                    value={this.state.fileList || []}
                                    defaultValue={this.state.fileList || []}
                                    beforeUpload={async (file) => {
                                        console.log('BeforeUpload - 文件信息:', file);
                                        if (!(file instanceof File)) {
                                            Toast.show({ icon: 'fail', content: '无效的文件！' });
                                            return false;
                                        }
                                        if (file.size > 5 * 1024 * 1024) {
                                            Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                            return false;
                                        }

                                        var res = await GetSystemMemorys(this.state.planetId);
                                        if (res.success) {
                                            var count = 0;
                                            res.result.map(item => {
                                                count += item.fileSize;
                                            })
                                            var maxSize = 300;
                                            var models = this.state.userInfo.planetSizes
                                                .filter(x => x.planetId == this.state.planetId);
                                            if (models != null && models.length > 0) {
                                                maxSize = models[0].fileSumSize;
                                            }
                                            if (count > maxSize) {
                                                Toast.show({ content: '该星球文件空间已满！' });
                                                return false;
                                            }
                                        }
                                        const fileCopy = new File([file], file.name, { type: file.type });
                                        this.setState({
                                            isSubmit: false,
                                            loadingProgress: 0,
                                            loadingType: 'progress',
                                        })
                                        this.simulateDataLoading();
                                        return fileCopy;
                                    }}
                                    onChange={(fileList) => {
                                        console.log('OnChange - 文件列表:', fileList);
                                        this.setState({
                                            isSubmit: true, 
                                            loadingType: '',
                                            fileList
                                        });
                                    }}
                                    upload={async (file) => {
                                        try {
                                            console.log('Upload - 开始上传:', file);

                                            // 1. 验证文件对象
                                            if (!(file instanceof File)) {
                                                throw new Error('无效的文件对象');
                                            }

                                            // 2. 创建临时预览URL
                                            const tempUrl = URL.createObjectURL(file);
                                            console.log('临时预览URL创建成功:', tempUrl);

                                            // 3. 上传文件
                                            const formData = new FormData();
                                            formData.append('file', file);
                                            formData.append('userid', this.state.userInfo.id);
                                            formData.append('scoureName', "XC");
                                            formData.append('planetId', this.state.planetId);

                                            const response = await SaveNNFile(formData);
                                            console.log('上传响应:', response);

                                            // 4. 确保返回正确的URL格式
                                            let imageUrl;
                                            if (typeof response === 'string') {
                                                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                            } else if (response.result) {
                                                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                            } else {
                                                throw new Error('无效的服务器响应');
                                            }

                                            this.setState({
                                                // isSubmit: true,
                                                imgName: response.result
                                            })
                                            // 5. 释放临时URL
                                            URL.revokeObjectURL(tempUrl);

                                            return {
                                                url: imageUrl
                                            };
                                        } catch (error) {
                                            console.error('上传过程出错:', error);
                                            Toast.show({ icon: 'fail', content: '上传失败' });
                                            throw error;
                                        }
                                    }}
                                    children={
                                        <Image src={"https://api.weibinyi.com/images/niannian/4/13-08.png"} fit='fill'
                                            width={90} height={90} />
                                    }
                                />


                                {
                                    isFull ? null :
                                        <div style={{ marginLeft: "6%" }}>
                                            {/* 自定义选择按钮：触发微信JS-SDK选择图片 */}
                                            <div
                                                onClick={this.chooseWxImage}
                                                style={{
                                                    marginTop: 10,
                                                    pointerEvents: isFull ? 'none' : 'auto',
                                                    opacity: isFull ? 0.5 : 1,
                                                    cursor: isFull ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                <Image
                                                    src={"https://api.weibinyi.com/images/niannian/4/13-08.png"}
                                                    fit='fill'
                                                    width={90}
                                                    height={90}
                                                />
                                            </div>
                                        </div>
                                }

                            </div>

                            <div style={{ borderBottom: "solid 2px #e2e2e2" }}></div>


                            <Form.Item className="xinyang" name='TabType' label="相册类型">
                                <div onClick={() => {
                                    this.setState({
                                        visibleOne: true
                                    })
                                }} style={{
                                    display: "flex",
                                    alignItems: "center", // 垂直居中
                                    justifyContent: "flex-end", // 内容右对齐
                                }}>
                                    <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                        {this.state.textPickerOne}
                                    </span>
                                    <span style={{ float: "right" }}>
                                        <RightOutline />
                                    </span>
                                </div>

                                <Picker
                                    columns={this.state.pickerOne}
                                    visible={this.state.visibleOne}
                                    onClose={() => {
                                        this.setState({
                                            visibleOne: false
                                        })
                                    }}
                                    value={[this.state.valuePickerOne]}
                                    onConfirm={(v) => {
                                        var value = v[0];
                                        var item = this.state.pickerOne[0].filter(x => x.value == value)
                                        this.setState({
                                            valuePickerOne: value,
                                            textPickerOne: item[0].label
                                        })
                                        this.loadAlbumClass(value, 0);
                                    }}
                                />
                            </Form.Item>

                            <div style={{ borderBottom: "solid 2px #e2e2e2" }}></div>

                            <Form.Item className="xinyang" name='PhotoType' label="照片类型">
                                <div onClick={() => {
                                    this.setState({
                                        visibleTwo: true
                                    })
                                }} style={{
                                    display: "flex",
                                    alignItems: "center", // 垂直居中
                                    justifyContent: "flex-end", // 内容右对齐
                                }}>
                                    <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                        {this.state.textPickerTwo}
                                    </span>
                                    <span style={{ float: "right" }}>
                                        <RightOutline />
                                    </span>
                                </div>

                                <Picker
                                    columns={this.state.pickerTwo}
                                    visible={this.state.visibleTwo}
                                    onClose={() => {
                                        this.setState({
                                            visibleTwo: false
                                        })
                                    }}
                                    value={[this.state.valuePickerTwo]}
                                    onConfirm={(v) => {
                                        var value = v[0];
                                        var item = this.state.pickerTwo[0].filter(x => x.value == value)
                                        this.setState({
                                            valuePickerTwo: value,
                                            textPickerTwo: item.length > 0 ? item[0].label : "请选择"
                                        })
                                    }}
                                />
                            </Form.Item>



                            <div style={{ borderBottom: "solid 2px #e2e2e2" }}></div>

                            <Form.Item className="xinyang1" name='ShootDate' 
                                label='拍摄时间' trigger='onConfirm'
                                onClick={(e, datePickerRef) => {
                                    datePickerRef.current.open()
                                }}
                            >
                                <DatePicker
                                    precision='month'
                                    min={new Date(1980, 0, 1)}
                                    max={new Date()}>
                                    {value =>
                                        value ? dayjs(value).format('YYYY-MM') : '请选择日期'
                                    }
                                </DatePicker>
                            </Form.Item>


                            <div style={{ borderBottom: "solid 2px #e2e2e2" }}></div>

                            {/* <div className="remark">
                                <div style={{
                                    marginTop: "10px", fontSize: "14px", marginLeft: "5px", fontWeight: "600"
                                }}>
                                    这里写下照片背后的小故事
                                </div>
                                <Form.Item name='Remark' label=''>
                                    <TextArea
                                        placeholder='这里写下照片背后的小故事'
                                        maxLength={500} rows={7} showCount
                                    />
                                </Form.Item>
                            </div> */}


                        </Form>


                    </div>


                </div>


                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);